import { useEffect } from "react";
import { createBrowserHistory } from "history";
import { useDispatch, useSelector } from "react-redux";
import { sessionActions } from "./../../../actions";
import useSession from "../../../hooks/Auth/useSession";
import _ from "lodash";

export default function SwitchAccount() {
  const { accessToken, user } = useSession();
  const dispatch = useDispatch();
  const changeOrgFetched = useSelector((state) => state.login.changeOrgFetched);
  const changeOrgError = useSelector((state) => state.login.changeOrgError);

  useEffect(() => {
    const history = createBrowserHistory();
    const customerId = _.get(history, "location.state.customerId", undefined);
    if (customerId) {
      dispatch(
        sessionActions.changeOrg(customerId, accessToken, user.initialUser),
      );
    } else {
      history.goBack();
    }
  }, [accessToken, dispatch, user.initialUser]);

  useEffect(() => {
    // Listen for successful organization change
    if (changeOrgFetched) {
      // Redirect to home page on success
      dispatch(sessionActions.resetChangeOrgState());
      window.location.href = "/";
      // Reset the state after redirect
    }
  }, [changeOrgFetched, dispatch]);

  useEffect(() => {
    // Handle error case
    if (changeOrgError) {
      console.error("Failed to change organization:", changeOrgError);
      const history = createBrowserHistory();
      history.goBack();
    }
  }, [changeOrgError]);

  return null;
}
